// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"605":"1744e6a8","883":"b78f0b35"}[chunkId] || chunkId) + "." + {"207":"fc0e7709c5952745","605":"52ecf8c32510f501","755":"68e1b4c64f76c6c3","785":"5ea364cfa905609b","883":"2d165087645c87d9"}[chunkId] + ".js";
};